<template>
    <div class="home-wrapper flex-height-max">
        <div class="home-wrapper-container">
            <div v-if="progress_bar_percentage > 0">
                <div class="progress">
                    <div class="progress-bar bg-success" role="progressbar" v-bind:style="'width:'+progress_bar_percentage+'%;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progress_bar_text}}</div>
                </div>
                <div style="text-align: left; font-size: 12px;">Setup progress</div>
            </div>
            <template>
                <div class="flex-height-max flex-row">
                    <div class="content">
                        <div class="header-home">
                            <div>
                                Congratulations! Your PPC Shield protection is activated
                            </div>
                        </div>
                        <div>
                            From now on, your Google Ads account is carefully protected by our advanced algorithm. No actions are required on your side. Keeping you safe from click fraud is on us!
                        </div>
                        <button class="btn btn-success w-100 mt-3" v-on:click="connectAnotherAccount">CONNECT ANOTHER ACCOUNT</button>
                        <button class="btn btn-primary w-100 mt-3" style="margin-bottom: 80px;" v-on:click="goToAccountPage">GO TO DASHBOARD</button>
                    </div>
                    <div class="content-right-side">
                        <img class="right-img" src="/images/PPC_Shield_Onboarding_Successful.png" alt="install tracking template">
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['progress_bar_percentage', 'progress_bar_text'],
        data: function () {
            return {

            }
        },
        methods: {
            goToAccountPage(){
                window.location = "/account";
            },
            connectAnotherAccount(){
                window.location = "/setup/connectGoogleAds";
            }
        },
        mounted() {

        }
    }
</script>
